import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

export function rateConfigList(data) { return axios.post(`${base.url}/payment/rateConfig/list`, qs.stringify(data)) }
export function rateConfigAddOrUpdate(data) { return axios.post(`${base.url}/payment/rateConfig/addOrUpdate`, JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } }) }
export function rateConfigDelete(ids) { return axios.post(`${base.url}/payment/rateConfig/deleteBatchIds`, qs.stringify({ ids })) }
export function rateConfigStatus(id, status) { return axios.post(`${base.url}/payment/rateConfig/status`, qs.stringify({ id, status })) }
